import { useEffect, useState } from "react";
import { Phone, Warehouse, Menu, X } from "lucide-react";
import { BUSINESS } from "@/data/content";

const NAV = [
  { label: "Home", href: "#top", testid: "nav-home" },
  { label: "Services", href: "#services", testid: "nav-services" },
  { label: "About us", href: "#about", testid: "nav-about-us" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="top-navbar"
      className="fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-300"
      style={{
        backgroundColor: scrolled ? "rgba(15,23,42,0.92)" : "rgba(15,23,42,0.55)",
        borderColor: "rgba(255,255,255,0.08)",
        backdropFilter: "saturate(180%) blur(10px)",
      }}
    >
      <div className="mx-auto flex h-[68px] max-w-6xl items-center justify-between px-4 sm:px-6">
        <a href="#top" data-testid="topbar-home" className="flex items-center gap-3">
          <span
            className="flex h-9 w-9 items-center justify-center rounded-lg"
            style={{ backgroundColor: "var(--brand-blue)" }}
          >
            <Warehouse size={18} className="text-white" />
          </span>
          <span className="leading-tight">
            <span className="block text-sm font-semibold text-white">{BUSINESS.name}</span>
            <span className="block text-[11px] text-slate-300">{BUSINESS.tagline}</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {NAV.map((n) => (
            <a
              key={n.label}
              href={n.href}
              data-testid={n.testid}
              className="rounded-lg px-3 py-2 text-sm font-semibold text-slate-200 transition-colors hover:text-white"
            >
              {n.label}
            </a>
          ))}
          <a
            href="#request"
            data-testid="nav-quote"
            className="ml-2 rounded-full border px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-white/10"
            style={{ borderColor: "rgba(255,255,255,0.25)" }}
          >
            Request Service
          </a>
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={BUSINESS.phoneHref}
            data-testid="topbar-call-button"
            className="flex items-center gap-2 rounded-full px-3 py-2 text-sm font-semibold text-white transition-transform hover:scale-105"
            style={{ backgroundColor: "var(--brand-blue)" }}
          >
            <Phone size={15} />
            <span className="hidden sm:inline">{BUSINESS.phone}</span>
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((o) => !o)}
            className="flex h-9 w-9 items-center justify-center rounded-lg text-white md:hidden"
            style={{ backgroundColor: "rgba(255,255,255,0.08)" }}
            aria-label="Menu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-[#0f172a] px-4 py-3 md:hidden" data-testid="mobile-menu">
          {[...NAV, { label: "Request Service", href: "#request", testid: "nav-quote-mobile" }].map((n) => (
            <a
              key={n.label}
              href={n.href}
              data-testid={n.testid}
              onClick={() => setOpen(false)}
              className="block rounded-lg px-3 py-3 text-sm font-semibold text-slate-200 hover:bg-white/5"
            >
              {n.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};
